'use strict';

import {
    addExportBtns,
    addSelectedCompanyHandler,
    fnToastrFormError, getSelectedCompany,
    localeFormattedNumber, pjaxRedirect
} from "../../jquery-functions-library";
import { element_exists, redesignDataTablesHeader } from "../../functions";

const queryString = require('query-string');
const setQuery = require('set-query-string');

function redesignFilters() {
    $('.page-on-top').addClass('page-on-top-down');

    const tableName = '#datatable-viia-transactions';
    const hasButtons = true;

    const { $filterButtons } = redesignDataTablesHeader(tableName, hasButtons, allLangFiles.viia.transactions.search);

    const transactionsColumnsBtn = $('.transactions-show-columns-btn');
    const exportDropDownButton = $(`
        <div class="dropdown dropdown-parent pull-right" id="viiaExportButtons">
            <a href="#" class="export-drop-down btn btn-primary" data-toggle="dropdown">
                <i class="fa fa-download"></i>
                ${allLangFiles.forms.export}
            </a>
            <div class="dropdown-menu dropdown-menu-cols dropdown-cols-1" id="exportButtonsContainer">
                   
            </div>
        </div>
    `);

    //$filterButtons.prepend(transactionsColumnsBtn);
    $filterButtons.prepend(exportDropDownButton);

    $('.btn-export-table').remove();
    $('#viiaExportButtons').addClass('btn-export-table').show();

    const exportButtonsDropdown = $('.dropdown_export .dt-buttons');
    let filteredExportButtons;

    for (let i = 0; i < exportButtonsDropdown.length; i++) {
        if (exportButtonsDropdown[i].childElementCount > 0) {
            filteredExportButtons = $(exportButtonsDropdown[i]).children();
        }
    }

    $('#exportButtonsContainer').append(filteredExportButtons);
}

export var fnViiaTransactionsTable = function () {

    var tableName = '#datatable-viia-transactions';

    if (!element_exists(tableName)) return false;

    var contentColumn = '.container-datatable-viia-transactions';
    setFilters();

    loadTransactions();

    addSelectedCompanyHandler(function () {
        // $(tableName).DataTable().clear().draw();
        pjaxRedirect('/viia');
        // window.location.reload();
    });

    function loadTransactions() {
        console.log('loading trans');
        var selectedCompany = getSelectedCompany();

        var companyGuard = selectedCompany !== 'default';

        if (companyGuard) {
            if ($.fn.dataTable.isDataTable(tableName)) {
                console.log('is already data table');
                $(tableName).DataTable().clear().draw();

                // $(tableName).parents('.table-responsive').removeClass('hidden');
                // $(contentColumn).removeClass('hidden');
                //
                // $(tableName).DataTable().ajax.load(function () {
                //     setTimeout(function () {
                //         $(tableName).parent('.dataTables_scrollBody').css('width', '100%');
                //     }, 500);
                // });
                return;
            }
            var columns = [
                {
                    data: 'date', render: function (data, type, row) {
                        return moment(data).format('DD-MM-YYYY');
                    }
                },
                { data: 'originalText' },
                { data: 'text' },
                {
                    data: 'detail', render: function (data, type, row) {
                        if (!data) return '';
                        return data.message;
                    }
                },
                { data: 'type' },
                {
                    data: 'transactionAmount.value', render: function (data, type, row) {
                        const transactionAmount = localeFormattedNumber(data);

                        if (Number(data) < 0) {
                            return `<span class="red">${transactionAmount}</span>`;
                        }

                        return `<span class="green">${transactionAmount}</span>`;
                    }
                },
                {
                    data: 'balance.value', render: function (data, type, row) {
                        console.log(row);
                        if (data === '' || data === null) {
                            return localeFormattedNumber(row.estimatedBalance.value) + ' (' + allLangFiles.viia.transactions.estimated + ')';
                        }

                        return localeFormattedNumber(data);
                    }
                },
                {
                    data: 'detail', render: function (data, type, row) {
                        if (!data) return '';
                        return JSON.stringify(data);//TODO dunno about this yet
                    }
                },
                { data: 'transferred_at' },
                { data: 'cashbook' },
            ];

            /*Rules for filling the columns*/
            var columnDefs;

            if ($(tableName).attr('data-can-edit') === '1') {
                columns.unshift({ data: 'select' });

                columnDefs = [
                    {
                        orderable: false,
                        checkboxes: {
                            selectRow: true
                        },
                        className: 'select-checkbox-gyro dt-center',
                        targets: 0,
                    },
                    { visible: false, targets: 3 },
                    { visible: false, targets: 8 },
                    { visible: false, targets: 9 },
                    { visible: false, targets: 10 }
                ];
            } else {
                columnDefs = [
                    { visible: false, targets: 5 },
                    { visible: false, targets: 6 },
                    { visible: false, targets: 7 }
                ];
            }


            /*Important otherwise table misaligned*/
            $(tableName).css('width', '100%');
            $.fn.dataTable.moment('DD-MM-YYYY');

            const options = {
                language: allLangFiles.datatables,
                rowId: 'id',
                colReorder: true,
                stateSave: true,
                stateLoadParams: (settings, data) => {
                    // Used to disable the saving of selections
                    // Because it was buggy and didn't work
                    if (typeof data.checkboxes !== 'undefined') {
                        delete data.checkboxes;
                    }
                },
                buttons: [
                    {
                        extend: 'colvis',
                        text: allLangFiles.datatables.show_columns,
                        className: 'transactions-show-columns-btn btn btn-primary'
                    }
                ],
                ajax: {
                    url: '/viia/transactions/' + selectedCompany + '/all',
                    data: function (d) {
                        d.transaction_from_amount = $('#transaction_from_amount').val();
                        d.transaction_to_amount = $('#transaction_to_amount').val();
                        d.transaction_from_date = $('#transaction_from_date').val();
                        d.transaction_to_date = $('#transaction_to_date').val();
                        d.account_id = $('#account_ids').val();
                    },
                    dataSrc: function (json) {
                        return json.data;
                    },
                    beforeSend: function () {
                        // Here, manually add the loading message.
                        $(this).find($('tbody')).html(`
                                <tr class="odd">
                                    <td colspan="100%" class="dataTables_empty">
                                        Loading...
                                    </td>
                                </tr>
                        `);
                    },
                    error: function (data) {
                        console.log(data);
                        var errors = '';
                        if (data.responseJSON && data.responseJSON.errors) {
                            for (var datos in data.responseJSON.errors) {
                                errors += data.responseJSON.errors[datos] + '<br>';
                            }
                            toastr.error(errors);
                        } else {
                            toastr.error(data.responseJSON.message);
                        }
                    }
                },
                serverSide: true,
                deferLoading: 1,
                columns: columns,
                columnDefs: columnDefs,
                order: [[$(tableName).attr('data-can-edit') === '1' ? 1 : 0, "desc"]],
                scrollX: true,
                lengthMenu: [[10, 25, 50, 75, 100, 250, 500, 1000], [10, 25, 50, 75, 100, 250, 500, 1000]],
                pageLength: 50,
                drawCallback: function (settings, json) {
                    $('#viiaTableLoading').remove();

                    $(tableName).DataTable().on('select', function () {
                        const count = $(tableName).DataTable().rows({ selected: true }).data().toArray().length;
                        $('#transferSelectedCount').html(count);
                    });

                    $(tableName).find($('td.select-checkbox-gyro input[type=checkbox].dt-checkboxes')).off('click').on('click', function (e) {
                        e.stopImmediatePropagation();
                        const row = $(this).closest('tr');
                        const rowData = $(tableName).DataTable().row(row).data();
                        let selectedRows = $(tableName).DataTable().rows({ selected: true }).data().toArray();

                        if (typeof selectedRows.find(row => {
                            return row.id === rowData.id;
                        }) === 'undefined') {
                            $(tableName).DataTable().row(row).select();
                            $(this).prop('checked', true);
                        } else {
                            $(tableName).DataTable().row(row).deselect();
                            $(this).prop('checked', false);
                        }

                        const allCheckbox = $('.dataTables_scrollHead .dt-checkboxes-select-all input[type=checkbox]');
                        selectedRows = $(tableName).DataTable().rows({ selected: true }).data().toArray();

                        if (selectedRows.length === 0) {
                            allCheckbox.prop('checked', false);
                            allCheckbox.prop('indeterminate', false);
                        }
                    });

                    $(tableName).DataTable().off('deselect').on('deselect', function (e, dt, type, indexes) {
                        const count = $(tableName).DataTable().rows({ selected: true }).data().toArray().length;
                        $('#transferSelectedCount').html(count);

                        for (let i = 0; i < indexes.length; i++) {
                            let checkbox = $($(tableName).DataTable().row(indexes[i]).node()).find($('td.select-checkbox-gyro input[type=checkbox].dt-checkboxes'));
                            let isChecked = checkbox.prop('checked');

                            if (isChecked) {
                                checkbox.prop('checked', false);
                            }
                        }
                    });
                }
            };

            if ($(tableName).attr('data-can-edit') === '1') {
                options.select = {
                    style: 'multi'
                };
            }

            var table = $(tableName).DataTable(options);
            /*$(tableName).DataTable().off('select').on('select', function(e, dt, type, indexes) {
                const count = dt.rows({selected: true}).data().toArray().length;

                for (let i = 0; i < indexes.length; i++) {
                    let checkbox = $(dt.row(indexes[i]).node()).find($('input[type=checkbox]'));
                    console.log(checkbox.prop('checked'))
                    // checkbox.prop('checked', true);
                }


            });

            $(tableName).DataTable().off('deselect').on('deselect', function(e, dt, type, indexes) {
                const count = dt.rows({selected: true}).data().toArray().length;

                for (let i = 0; i < indexes.length; i++) {
                    let checkbox = $(dt.row(indexes[i]).node()).find($('input[type=checkbox]'));
                    console.log(checkbox.prop('checked'))
                    // checkbox.prop('checked', false);
                }

                $('#transferSelectedCount').html(count);
            });*/

            addFilteringFromToDate(tableName);

            //addSearchColumn(tableName, table);
            addExportBtns($(tableName));
            addExpandableColumn(tableName, table);

            addTransferButtonListener($(tableName));

            moveShowColumnsButton();
            redesignFilters();
            addSubmitListenerToTransferForm(table);
        } else {
            $(tableName).parents('.table-responsive').addClass('hidden');
            $(contentColumn).addClass('hidden');
            $(tableName).DataTable().clear().draw();
            console.log('drawing table');
        }
        $.fn.dataTable.ext.errMode = function (settings, helpPage, message) {
            // console.log(settings);
            // console.log(helpPage);
            // console.log(message);
            toastr.error('Error loading page');
            // pjaxRedirect(window.location);
            // $('#viia-page').trigger('click')//TODO find out if good idea
        };
    }
};

function addExpandableColumn(tableName, table) {
    $(tableName + ' tbody').off('click', 'tr.even td:not(.select-checkbox-gyro), tr.odd td:not(.select-checkbox-gyro)');

    $(tableName + ' tbody').on(
        'click',
        'tr.even td:not(.select-checkbox-gyro), tr.odd td:not(.select-checkbox-gyro)',
        function (e) {
            e.stopPropagation();

            let tr = $(this).parent();
            let row = table.row(tr);

            if (row.child.isShown()) {
                row.child.hide();
                tr.removeClass('shown');
            } else {

                let data = row.data();

                if (data === undefined) return false;


                let $html = getTransactionView(data, allLangFiles.viia.transactions.inner_table);//Do something with data

                row.child($html).show();
                tr.addClass('shown');

            }
        })
        .children().on('click', function (e) {
            e.preventDefault();
        });
}

function getTransactionView(data, headers) {
    let deletedCheckbox = `<input class="form-control" type="checkbox" ${data.isDeleted ? 'checked' : ''} disabled>`;
    let creationDateFormatted = moment(data.creationDate).format('DD-MM-YYYY HH:MM:SS');
    let estimatedBalanceFormatted = localeFormattedNumber(data.estimatedBalance.value);

    return `
    <table class="expandable-table-column table no-hover table-striped table-condensed cell-border" cellpadding="5"
       cellspacing="0" border="0"
       style="padding-left:50px; word-break: break-all">
    <thead>
        <tr>
            <!--<th>${headers.account_id}</th>
            <th>${headers.transaction_id}</th>-->
            <th>${headers.estimated_balance}</th>
            <th>${headers.is_deleted}</th>
            <!--<th>${headers.api_transaction_id}</th>-->
            <th>${headers.original_text}</th>
            <!--<th>${headers.creation_date}</th>-->
        </tr>    
    </thead>
        <tbody>
            <tr>
                <!--<td>${data.accountId}</td>
                <td>${data.id}</td>-->
                <td>${estimatedBalanceFormatted}</td>
                <td>${deletedCheckbox}</td>
                <!--<td>${data.nagApiTransactionId}</td>-->
                <td>${data.originalText}</td>
                <!--<td>${creationDateFormatted}</td>-->
            </tr>
        </tbody>
    </table>
    `;
}

function addFilteringFromToDate(tableName) {

    $('#btn_search_transaction_interval').off('click').on('click', function () {
        setQuery({
            transaction_from_amount: $('#transaction_from_amount').val(),
            transaction_to_amount: $('#transaction_to_amount').val(),
            transaction_from_date: $('#transaction_from_date').val(),
            transaction_to_date: $('#transaction_to_date').val(),
            account_id: $('#account_ids').val()
        });

        if ($(this).find($('#viiaTableLoading')).length === 0) {
            $(this).prepend(`<i class="fa fa-circle-o-notch" id="viiaTableLoading"></i>`);
        }

        $(tableName).DataTable().ajax.reload();
    });
}

function setFilters() {
    const parsed = queryString.parse(location.search);

    if (parsed.transaction_from_amount) {
        $('#transaction_from_amount').val(parsed.transaction_from_amount);
    }
    if (parsed.transaction_to_amount) {
        $('#transaction_to_amount').val(parsed.transaction_to_amount);
    }

    if (parsed.transaction_from_date) {
        $('#transaction_from_date').val(parsed.transaction_from_date);
    }
    if (parsed.transaction_to_date) {
        $('#transaction_to_date').val(parsed.transaction_to_date);
    }
    if (parsed.account_id) {
        $('#account_ids').val(parsed.account_id).change();
    }
    console.log('filters set');
}

function moveShowColumnsButton() {
    const button = $('.transactions-show-columns-btn');
    const rowAmountChooser = $('#datatable-viia-transactions_length');

    button.insertAfter(rowAmountChooser);

    button.prepend(`<i class="fa fa-filter"></i>`);

    button.removeClass();
    button.addClass('transactions-show-columns-btn')
        .addClass('btn')
        .addClass('btn-outline');

    let activeCount = $('#datatable-viia-transactions').DataTable().columns().visible().toArray().reduce((acc, column) => {
        return acc + (column ? 1 : 0);
    });

    if ($('#datatable-viia-transactions').attr('data-can-edit') === '1') {
        activeCount -= 1;
    }

    const content = button.find($('span')).html();
    button.find($('span')).html(`${content} <span id="filterActiveCount">(${activeCount})</span>`);

    $(document).off('click', '.transactions-show-columns-btn')
        .on('click', '.transactions-show-columns-btn', function () {
            const dtButtons = $(document).find($('.dt-button'));
            let buttonText;
            let isActive;

            for (let i = 0; i < dtButtons.length; i++) {
                let buttonSpan = $(dtButtons[i]).find($('span'));
                buttonText = buttonSpan.html();

                if ($(dtButtons[i]).find($('input')).length === 0) {
                    if (buttonText !== '') {
                        isActive = $(dtButtons[i]).hasClass('active');

                        $(dtButtons[i]).prepend(`
                            <span class="bmd-form-group is-filled">
                                <div class="checkbox checkbox-secondary">
                                    <label class="m-b-0 toggle-view-column">
                                        <input class="form-control" type="checkbox"
                                               value="1"
                                               ${isActive ? 'checked="checked"' : ''}>
                                        <span class="checkbox-decorator">
                                            <span class="check"></span>
                                        </span>
                                        ${buttonText}
                                    </label>
                                </div>
                            </span>
                        `);

                        buttonSpan.remove();
                    } else {
                        $(dtButtons[i]).remove();
                    }
                }
            }

            const activeCount = dtButtons.find($('input:checked')).length;

            $('#filterActiveCount').html(`(${activeCount})`);

            const transactionButton = $(this);

            $(document).off('click', '.dt-button').on('click', '.dt-button', function () {
                const checkbox = $(this).find($('input[type=checkbox]'));
                checkbox.prop('checked', !checkbox.prop('checked'));

                const activeCount = dtButtons.find($('input:checked')).length;
                $('#filterActiveCount').html(`(${activeCount})`);
            });
        });
}

function addTransferButtonListener(table) {
    $('#transferToEconomicForm').validateFormListen({
        cashBook: {
            presence: {
                allowEmpty: false
            }
        }
    }, function (invalid) {
        $('#submitTransferToEconomicForm').prop('disabled', invalid);
    });

    $(document).off('click', '#btn-transfer-to-economic').on('click', '#btn-transfer-to-economic', function () {
        const selectedRows = table.DataTable().rows({ selected: true }).data();
        const selectedRowsCount = selectedRows.length;

        $('#modal-transfer-to-economic').modal('show');

        $('#transactionRowsChosen').html(selectedRowsCount);

        const selectedCompanyId = getSelectedCompany();
        const $cashbookSelect = $('#cashBooksToTransfer');
        const $cashbookTypeSelect = $('#cashBookTypeSelect');

        $cashbookSelect.css('width', '100%');
        $cashbookTypeSelect.css('width', '100%');

        $cashbookSelect.select2({
            ajax: {
                url: `/viia/transactions/${selectedCompanyId}/cash-books/`,
                dataType: 'json',
                processResults(cashbooks) {
                    return {
                        results: cashbooks.map(cashbook => {
                            return {
                                id: cashbook.journalNumber,
                                text: cashbook.name
                            };
                        })
                    }
                }
            },
            placeholder: allLangFiles.viia.select_a_cashbook
        });

        $.ajax({
            url: `/viia/transactions/${selectedCompanyId}/cash-book-types/`,
            success(cashBookTypes) {
                $cashbookTypeSelect.select2({
                    data: cashBookTypes
                })
            },
            error(error) {
                toastr.error(allLangFiles.forms.generic_error);
            }
        });
    });
}

function addSubmitListenerToTransferForm(table) {
    const $form = $('#transferToEconomicForm');

    $(document).off('click', '#submitTransferToEconomicForm').on('click', '#submitTransferToEconomicForm', function () {
        const url = $form.attr('action');
        const cashbookHandle = $form.find('#cashBooksToTransfer').val();
        const cashBookType = $form.find('#cashBookTypeSelect').val();
        const transactions = table.rows({ selected: true }).data().toArray();
        const accountId = transactions[0].accountId;
        const transactionIds = transactions.map(transaction => transaction.id);

        $.ajax({
            url: url,
            method: 'POST',
            data: {
                transactions: transactionIds,
                cashbook_id: cashbookHandle,
                accountId: accountId,
                cashBookType: cashBookType
            },
            success() {
                toastr.success(allLangFiles.viia.transactions.transferredToCashBook);
                table.ajax.reload();
                $('#modal-transfer-to-economic').modal('hide');
            },
            error() {
                toastr.error(allLangFiles.forms.generic_error);
            }
        });
    });
}